import React from 'react';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import AuthenticationSettingsView from './AuthenticationSettingsView';
import SettingsModel from './SettingsModel';
import { Form, IFormContext } from 'rewire-ui';
import mainPageModel from '../main-navigation/MainPageModel';
import DataQueries from '../graphql/Queries';
import Mutations from '../graphql/Mutations';
import { Observe } from 'rewire-core';
import { ISAMLIdentityProvider } from '../DataTypes';
import { notifications } from '../ui/Notifications';
import IconButton from '@material-ui/core/IconButton';

interface IAuthenticationState {
  apple: boolean;
  usernamePassword: boolean;
  saml: boolean;
  mfa: boolean;
  refresh: number;
}

function copyToClipboard(form: IFormContext, copyFn: () => string) {
  return form.string({ readOnly: true }).endAdornment(() => (
    <Observe>
      {() => (
        <IconButton
          title={`Copy '${copyFn()}'`}
          style={{ color: '#241b1a' }}
          onClick={() => navigator.clipboard.writeText(copyFn())}
          size="small"
        >
          <CopyIcon style={{ height: 22 }} />
        </IconButton>
      )}
    </Observe>
  ));
}

const props = ['apple', 'usernamePassword', 'saml', 'mfa'];

export default class AuthenticationSettingsModel extends SettingsModel<IAuthenticationState> {
  originalState: any;
  form: ReturnType<AuthenticationSettingsModel['initializeForm']>;

  canSave(): boolean {
    this.state.refresh;
    for (const key of props) {
      if ((this.state as any)[key] !== this.originalState[key]) {
        return true;
      }
    }
    return this.form.hasChanges;
    // return false;
  }

  async save(): Promise<boolean> {
    if (!this.canSave()) {
      return false;
    }
    const provider = this.form.toObject() as ISAMLIdentityProvider;
    try {
      await Mutations.saveAuthenticationOptions({
        provider,
        apple: this.apple,
        saml: this.saml,
        usernamePassword: this.usernamePassword,
        mfa: this.mfa,
      });
      this.originalState = { ...this.state };
      this.form.value = provider;
      notifications.success('Authentication settings saved');
      this.state.refresh++;
      return true;
    } catch (err) {
      notifications.error(`Error saving authentication settings: '${err}`);
      return false;
    }
  }

  constructor() {
    super('Authentication');
    // this.title = 'Generate Authentication Key';
    // this.SettingsView = AuthenticationSettingsItemsPanelView;
    this.originalState = { apple: false, saml: true, usernamePassword: true, mfa: false };
    this.state.refresh = 0;
    Object.assign(this.state, this.originalState);

    this.SettingsView = AuthenticationSettingsView;
    this.form = this.initializeForm(this);
  }

  initializeForm(self: any) {
    return Form.create(
      (form: IFormContext) => ({
        metadataURL: form.string().label('Metadata URL').updateOnChange(),
        entityID: copyToClipboard(form, () => self.form?.getField('entityID')?.value).label('Entity ID'),
        replyURL: copyToClipboard(form, () => self.form?.getField('replyURL')?.value).label('Reply URL'),
      }),
      {},
    );
  }

  get apple() {
    return this.state.apple;
  }
  set apple(value: boolean) {
    this.state.apple = value;
  }

  get saml() {
    return this.state.saml;
  }
  set saml(value: boolean) {
    this.state.saml = value;
  }

  get mfa() {
    return this.state.mfa;
  }
  set mfa(value: boolean) {
    this.state.mfa = value;
  }

  get usernamePassword() {
    return this.state.usernamePassword;
  }
  set usernamePassword(value: boolean) {
    this.state.usernamePassword = value;
  }

  get access() {
    return mainPageModel.apiAccess;
  }

  protected _handleOnSubmit() {
    super._handleOnSubmit();
    // this._reload(this);
  }

  async loadAuthenticationOptions(): Promise<void> {
    const authenticationOptions = await DataQueries.getAuthenticationOptions();
    if (authenticationOptions?.provider) {
      this.form.value = authenticationOptions.provider;
      delete authenticationOptions.provider;
    }
    Object.assign(this.originalState, authenticationOptions);
    Object.assign(this.state, authenticationOptions);
  }

  // canAddItem() {
  //   return true;
  // }

  // canDeleteItem(): boolean {
  //   if (!this.selectedItem) {
  //     return false;
  //   }

  //   return true;
  // }

  async load() {
    try {
      this.isLoading = true;
      if (this.state.saml) {
        await this.loadAuthenticationOptions();
      }
    } finally {
      this.isLoading = false;
    }
  }

  protected async _load(_filter?: { search?: string }) {
    this.load();
    return { totalCount: 0, data: [], cursor: '100' };
  }
}
